/**
 * 数组根据某个字段去重
 * @param {*} arr 需要去重的数组
 * @param {*} val 字段媒介
 * @returns 
 */
export const unique = function (arr, val) {
    const res = new Map();
    return arr.filter((item) => !res.has(item[val]) && res.set(item[val],1))
}